import React, { useLayoutEffect, useState } from "react";
import { useAuth } from "../../authProvider";
import "./index.scss";
import iconSearch from "../../../assets/Search.png";

function Header() {
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const { currentUser } = useAuth();
  const { handelLogout } = useAuth();
  const [filteredData, setFilteredData] = useState([]);
  const [devisList, setDevisList] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Add search query state

  // Handle search filtering

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query); // Update search query state

    // Filter devis list based on the search query
    const filtered = devisList.filter(
      (devis) =>
        devis.clientId?.firstname.toLowerCase().includes(query) ||
        devis?.description.toLowerCase().includes(query) // Example: also search in description
    );
    setFilteredData(filtered); // Update filteredData state with filtered items
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <header
        id="header"
        className="header fixed-top d-flex align-items-center px-4 "
      >
        {/* <div className="d-flex gap-3 align-items-center">
          <div className="search-container py-3">
            <div className="search-input-wrapper position-relative">
              <img src={iconSearch} alt="search icon" className="search-icon" />
              <input
                type="text"
                id="search-input"
                className="form-control ps-5 pe-5" // ps-5 adds left padding so the icon doesn’t overlap text
                placeholder="Rechercher ..."
                value={searchQuery} // Bind search query to input value
                onChange={handleSearch}
              />
            </div>
          </div>
        </div> */}
        <div className=" d-flex row align-items-center justify-content-between w-100">
          <div className="d-flex align-center justify-content-end">
            <div
              className={
                " d-flex align-items-center justify-content-lg-center justify-content-end"
              }
            >
              <img
                src={`${currentUser?.image}`}
                className="sidebar_avatar me-2"
                alt="photo de profil"
              />

              <div className="d-flex dropdown justify-content-center align-items-center flex-column">
                <h6>{currentUser?.firstname}</h6>
                <div>
                  <div>{currentUser?.role}</div>
                </div>
              </div>
             <div>    </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
